import React, { useState, useEffect, useRef } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { SelectChangeEvent } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { TextComponent, SelectComponent } from '../uiComponents';
import { EnumerationComponent } from '../gritComponents';
import { Claim, Enumeration } from '../../xmlParsing/interfaces';
import { gritComponentStyles } from './gritComponentStyles';
import { useSelector } from 'react-redux';
import { getClaims } from '../../store';
import CONSTANTS from '../../constants/constants';
import { OptionProps } from '../../view-models';
import { init_Claim } from '../../xmlParsing/initInterfaces';

interface ClaimComponentProps {
  data: Claim;
  parentClaimError?: string;
  changeHandler: (data: Claim) => void;
}
function ClaimComponent({ data, parentClaimError, changeHandler }: ClaimComponentProps) {
  const initData = useRef<Claim>(data);
  const [modifiedData, setModifiedData] = useState<Claim>(init_Claim());
  const [applyMask, setApplyMask] = useState<string>('');
  const [showPattern, setShowPattern] = useState<string>('');
  const [claimError, setClaimError] = useState<string>('Should not be empty');
  const classes = gritComponentStyles();
  const allClaims = useSelector(getClaims);
  useEffect(() => {
    setModifiedData(data);
  }, [initData]);

  useEffect(() => {
    changeHandler(modifiedData);
    modifiedData.hasOwnProperty('mask') ? setApplyMask(applyMask || Object.keys(CONSTANTS.MASK)[0]) : setApplyMask('');
    modifiedData.hasOwnProperty('pattern')
      ? setShowPattern(showPattern || Object.keys(CONSTANTS.PATTERN)[0])
      : setShowPattern('');
  }, [modifiedData]);

  const setRestAndMask = (dataType: string, userInputType: string) => {
    const _obj = modifiedData;
    if (dataType === 'boolean') {
      delete _obj?.mask;
    }
    delete _obj['pattern'];
    if (['CheckboxMultiSelect', 'DropdownSingleSelect', 'RadioSingleSelect'].includes(userInputType)) {
      setModifiedData({
        ..._obj,
        dataType: dataType,
        userInputType: userInputType,
        restriction: 'Enumeration',
        enumeration:
          dataType === 'boolean'
            ? [
                { value: 'true', text: 'True', selectByDefault: false },
                { value: 'false', text: 'False', selectByDefault: false },
              ]
            : _obj['enumeration'] || [],
      });
    } else {
      // TextBox', ', 'Readonly', 'Password', 'Paragraph', 'EmailBox', 'DateTimeDropdown'
      delete _obj['restriction'];
      delete _obj['enumeration'];
      setModifiedData({ ..._obj, dataType: dataType, userInputType: userInputType });
      if (['TextBox'].includes(userInputType)) {
        setShowPattern('');
      }
    }
  };

  return (
    <div className={classes.flexCol}>
      <div>
        <TextComponent
          changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            if (e.target.value === '') {
              setClaimError('Should not be empty');
            } else if (!/^[a-zA-Z0-9]+[a-zA-Z0-9_-]{0,}$/.test(e.target.value)) {
              setClaimError(
                'Should begin with an alphabet or number and can contain alphabets, numbers and the following symbols: _ -',
              );
            } else if (
              Object.keys(allClaims).findIndex(
                (el: string) => el.trim().toLowerCase() === e.target.value.trim().toLowerCase(),
              ) >= 0
            ) {
              setClaimError('A claimTypeReferenceId exists with the same name');
            } else {
              setClaimError('');
            }
            setModifiedData({ ...modifiedData, id: e.target.value });
          }}
          data={{
            value: modifiedData.id || '',
            label: 'ClaimTypeReferenceId',
            error: !!parentClaimError || !!claimError,
            style: { margin: 1, width: 400 },
            helperText: parentClaimError || claimError,
          }}
        />
      </div>
      <div>
        <TextComponent
          changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            setModifiedData({ ...modifiedData, displayName: e.target.value });
          }}
          data={{
            value: modifiedData.displayName || '',
            label: 'Display Name',
          }}
        />
        <SelectComponent
          changeHandler={(e: SelectChangeEvent<string>) => {
            setRestAndMask(e.target.value, modifiedData['userInputType']);
          }}
          data={{
            value: modifiedData['dataType'],
            label: 'Data Type',
            options: [
              { label: 'string', value: 'string' },
              { label: 'boolean', value: 'boolean' },
            ],
          }}
        />
        <SelectComponent
          changeHandler={(e: SelectChangeEvent<string>) => {
            setRestAndMask(modifiedData['dataType'], e.target.value);
          }}
          data={{
            value: modifiedData['userInputType'] || '',
            label: 'User Input Type',
            options: [
              { label: 'Clear User Input Type', value: '' },
              { label: 'TextBox', value: 'TextBox' },
              { label: 'Readonly', value: 'Readonly' },
              { label: 'RadioSingleSelect', value: 'RadioSingleSelect' },
              { label: 'Password', value: 'Password' },
              { label: 'Paragraph', value: 'Paragraph' },
              { label: 'EmailBox', value: 'EmailBox' },
              { label: 'DropdownSingleSelect', value: 'DropdownSingleSelect' },
              { label: 'DateTimeDropdown', value: 'DateTimeDropdown' },
              { label: 'CheckboxMultiSelect', value: 'CheckboxMultiSelect' },
            ],
          }}
        />
        {['CheckboxMultiSelect', 'DropdownSingleSelect', 'RadioSingleSelect'].includes(modifiedData['userInputType']) &&
          modifiedData['dataType'] === 'string' && (
            <EnumerationComponent
              list={modifiedData?.enumeration || []}
              onChangeEnumeration={(enumData: Enumeration[]) => {
                setModifiedData({ ...modifiedData, enumeration: enumData });
              }}
            />
          )}
        {['TextBox'].includes(modifiedData['userInputType']) && modifiedData['dataType'] === 'string' && (
          <div className={classes.flexCol}>
            <div>
              <FormControlLabel
                sx={{ m: 0 }}
                label="Validate Pattern"
                control={
                  <Checkbox
                    checked={!!showPattern}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      if (!!showPattern) {
                        setShowPattern('');
                        const _obj = modifiedData;
                        delete _obj['restriction'];
                        delete _obj['pattern'];
                        delete _obj['enumeration'];
                        setModifiedData(_obj);
                      } else {
                        const _tempPattern: string = Object.keys(CONSTANTS.PATTERN)[0];
                        setShowPattern(_tempPattern);
                        const _obj = modifiedData;
                        delete _obj['enumeration'];
                        setModifiedData({
                          ..._obj,
                          restriction: 'Pattern',
                          pattern: {
                            // @ts-ignore
                            regularExpression: CONSTANTS.PATTERN[_tempPattern][0],
                            // @ts-ignore
                            helpText: CONSTANTS.PATTERN[_tempPattern][1],
                          },
                        });
                      }
                    }}
                  />
                }
              />
            </div>
            {!!showPattern && (
              <div className={classes.flexRow}>
                <SelectComponent
                  changeHandler={(e: SelectChangeEvent<string>) => {
                    setShowPattern(e.target.value);
                    setModifiedData({
                      ...modifiedData,
                      restriction: 'Pattern',
                      pattern: {
                        // @ts-ignore
                        regularExpression: CONSTANTS.PATTERN[e.target.value][0],
                        // @ts-ignore
                        helpText: CONSTANTS.PATTERN[e.target.value][1],
                      },
                    });
                  }}
                  data={{
                    value: showPattern,
                    label: 'Select Pattern',
                    options: Object.keys(CONSTANTS.PATTERN).reduce(
                      (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
                      [],
                    ),
                  }}
                />
                <TextComponent
                  changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                    setShowPattern('CustomRegex');
                    setModifiedData({
                      ...modifiedData,
                      restriction: 'Pattern',
                      pattern: {
                        regularExpression: e.target.value,
                        helpText: (modifiedData['pattern'] && modifiedData['pattern']['helpText']) || '',
                      },
                    });
                  }}
                  data={{
                    value: (modifiedData['pattern'] && modifiedData['pattern']['regularExpression']) || '',
                    label: 'Regular Expression',
                    error: (modifiedData['pattern'] && modifiedData['pattern']['regularExpression'].trim()) === '',
                    style: { margin: 1, width: 400 },
                    helperText:
                      (modifiedData['pattern'] && modifiedData['pattern']['regularExpression'].trim()) === ''
                        ? 'Enter a valid regular expression'
                        : '',
                  }}
                />
                <TextComponent
                  changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                    setModifiedData({
                      ...modifiedData,
                      restriction: 'Pattern',
                      pattern: {
                        regularExpression:
                          (modifiedData['pattern'] && modifiedData['pattern']['regularExpression']) || '',
                        helpText: e.target.value,
                      },
                    });
                  }}
                  data={{
                    value: (modifiedData['pattern'] && modifiedData['pattern']['helpText']) || '',
                    label: 'Help Text',
                    style: { margin: 1, width: 300 },
                    helperText: 'Regex fail message.',
                  }}
                />
              </div>
            )}
          </div>
        )}

        <TextComponent
          changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            setModifiedData({ ...modifiedData, userHelpText: e.target.value });
          }}
          data={{
            value: modifiedData.userHelpText || '',
            label: 'User Help Text',
          }}
        />
        <TextComponent
          changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            setModifiedData({ ...modifiedData, adminHelpText: e.target.value });
          }}
          data={{
            value: modifiedData.adminHelpText || '',
            label: 'Admin Help Text',
          }}
        />
        {modifiedData['dataType'] === 'string' && (
          <div className={classes.flexRow}>
            <FormControlLabel
              sx={{ m: 0 }}
              label="Apply Mask"
              control={
                <Checkbox
                  checked={!!applyMask}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (applyMask) {
                      setApplyMask('');
                      const _obj = modifiedData;
                      delete _obj['mask'];
                      setModifiedData(_obj);
                    } else {
                      const _tempMask = Object.keys(CONSTANTS.MASK)[0];
                      setApplyMask(_tempMask);
                      setModifiedData({
                        ...modifiedData,
                        mask: {
                          // @ts-ignore
                          type: CONSTANTS.MASK[_tempMask][0],
                          // @ts-ignore
                          regex: CONSTANTS.MASK[_tempMask][1],
                          // @ts-ignore
                          value: CONSTANTS.MASK[_tempMask][2],
                        },
                      });
                    }
                  }}
                />
              }
            />
            {applyMask && (
              <SelectComponent
                changeHandler={(e: SelectChangeEvent<string>) => {
                  setApplyMask(e.target.value);
                  setModifiedData({
                    ...modifiedData,
                    mask: {
                      // @ts-ignore
                      type: CONSTANTS.MASK[e.target.value][0],
                      // @ts-ignore
                      regex: CONSTANTS.MASK[e.target.value][1],
                      // @ts-ignore
                      value: CONSTANTS.MASK[e.target.value][2],
                    },
                  });
                }}
                data={{
                  value: applyMask,
                  label: 'Select Mask',
                  options: Object.keys(CONSTANTS.MASK).reduce(
                    (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
                    [],
                  ),
                }}
              />
            )}

            {modifiedData?.mask?.type === 'Simple' && (
              <TextComponent
                changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                  setModifiedData({
                    ...modifiedData,
                    mask: {
                      type: 'Simple',
                      regex: '',
                      value: e.target.value,
                    },
                  });
                }}
                data={{
                  value: (modifiedData['mask'] && modifiedData['mask']['value']) || '',
                  label: 'Value',
                  style: { margin: 1, width: 600 },
                }}
              />
            )}
            {modifiedData?.mask?.type === 'Regex' && (
              <TextComponent
                changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                  setApplyMask('CustomRegex');
                  setModifiedData({
                    ...modifiedData,
                    mask: {
                      type: 'Regex',
                      regex: e.target.value,
                      value: '*',
                    },
                  });
                }}
                data={{
                  value: (modifiedData['mask'] && modifiedData['mask']['regex']) || '',
                  label: 'Regex',
                  error: modifiedData['mask'] && modifiedData['mask']['regex'].trim() === '',
                  style: { margin: 1, width: 600 },
                  helperText:
                    modifiedData['mask'] && modifiedData['mask']['regex'].trim() === ''
                      ? 'Enter a valid regular expression'
                      : '',
                }}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// export default withAITracking(reactPlugin, ClaimComponent);
export default ClaimComponent;
